export const GoogleMapApiConfig = 'AIzaSyDmRtK1h7ULrHVmAcoK8k7eWY3LQlJ5-1A';